export const environment = {
  siteUrl: 'http://localhost:4200',
  googleAnalyticsId: '',
  pageTitle: 'Glacies Admin',
  apiUrl: 'https://api.staging.glacies.ai',
};
